/**
 * The 1 Hz heart-rate trace, read from the record (global 20) messages. Edits never touch these
 * records, so the trace is the watch's original signal for the whole activity. Pure.
 */
import type { DataRecord, FitFile } from '../codec/types'
import { GLOBAL, REC, getNumber } from '../domain/fields'

/** Valid HR samples (bpm) in chronological order; invalid/absent readings are dropped. */
export function heartRateSamples(file: FitFile): number[] {
  const out: number[] = []
  for (const r of file.records) {
    if (r.kind !== 'data' || r.def.globalMessageNumber !== GLOBAL.record) continue
    const hr = getNumber(r as DataRecord, REC.heartRate)
    if (hr !== undefined && hr > 0 && hr < 255) out.push(hr)
  }
  return out
}

/** Evenly thin a series to at most `max` points (keeps the shape, cheaper to draw). */
export function downsample(values: number[], max: number): number[] {
  if (values.length <= max) return values
  const step = values.length / max
  const out: number[] = []
  for (let i = 0; i < max; i++) out.push(values[Math.floor(i * step)]!)
  return out
}
